import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { ICollaboratorData, IDTProject } from "src/pages/Studies/models/interfaces";

interface DTProjectsState {
  dtProjects: IDTProject[];
  dtSearch: string;
  isLoading: boolean;
}

export const initialState: DTProjectsState = {
  dtProjects: [],
  dtSearch: "",
  isLoading: false,
};

const dtProjectsSlice = createSlice({
  name: "dtProjectsSlice",
  initialState,
  reducers: {
    setDTProjects: (state, action: PayloadAction<IDTProject[]>) => {
      state.dtProjects = action.payload;
    },

    upsertDTProject: (state, action: PayloadAction<IDTProject>) => {
      const idx = state.dtProjects.findIndex(
        (p) => p.id === action.payload.id
      );
      if (idx >= 0) {
        state.dtProjects[idx] = action.payload;
      } else {
        state.dtProjects.unshift(action.payload);
      }
    },

    deleteDTProject: (state, action: PayloadAction<string>) => {
      state.dtProjects = state.dtProjects.filter(
        (p) => p.id !== action.payload
      );
    },

    setDTSearch: (state, action: PayloadAction<string>) => {
      state.dtSearch = action.payload;
    },

    setDTLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },

    updateDTProjectCollaborators: (
      state,
      action: PayloadAction<{ project_id: string; collaborators: ICollaboratorData[] }>
    ) => {
      const { project_id, collaborators } = action.payload;
      const project = state.dtProjects.find((p) => p.id === project_id);
      if (project) {
        project.project_collaborators = collaborators;
      }
    },

    resetDTProjects: () => initialState,
  },
});

export const {
  setDTProjects,
  upsertDTProject,
  deleteDTProject,
  setDTSearch,
  setDTLoading,
  updateDTProjectCollaborators,
  resetDTProjects,
} = dtProjectsSlice.actions;
export default dtProjectsSlice.reducer;
